import { t } from "i18next";

import { PartTypeType } from "shared";

export const partTypesWordingMap: Record<PartTypeType, string> = {
  SHEET: t("part.type.SHEET"),
  MACHINING: t("part.type.MACHINING"),
  CONSUMABLE: t("part.type.CONSUMABLE"),
  ROUND_TUBE: t("part.type.ROUND_TUBE"),
  SQUARE_TUBE: t("part.type.SQUARE_TUBE"),
  RECTANGULAR_TUBE: t("part.type.RECTANGULAR_TUBE"),
  PROFILE: t("part.type.PROFILE"),
  ROUND_BAR: t("part.type.ROUND_BAR"),
  SQUARE_BAR: t("part.type.SQUARE_BAR"),
  OTHER: t("part.type.OTHER"),
  ASSEMBLY: t("part.type.ASSEMBLY"),
};
